import { render, staticRenderFns } from "./ThreadRenamingModal.vue?vue&type=template&id=9dbd4a30&"
import script from "./ThreadRenamingModal.vue?vue&type=script&lang=js&"
export * from "./ThreadRenamingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports